"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var domain_1 = require("./domain");

var utils_1 = require("./utils");

exports.LinebreakRule = {
  name: 'Linebreak',
  scope: domain_1.RuleScope.INLINE,
  regex: /\n(?!\n)/,
  parse: function parse(match) {
    return {
      name: this.name,
      content: []
    };
  },
  react: function react(node) {
    return {
      type: 'br'
    };
  }
};
exports.ParagraphRule = {
  name: 'Paragraph',
  scope: domain_1.RuleScope.BLOCK,
  regex: /((?:.|\s)+?)(?:\n{2,}|$)/,
  parse: function parse(match) {
    return {
      name: this.name,
      content: [match.capture[0]]
    };
  },
  react: function react(node) {
    return {
      type: 'p'
    };
  }
};
exports.HighlightRule = {
  name: 'Highlight',
  scope: domain_1.RuleScope.INLINE,
  regex: /\*([^*]+?)\*(?!\*)/,
  parse: function parse(match) {
    return {
      name: this.name,
      content: [match.capture[0]]
    };
  },
  react: function react(node) {
    return {
      type: 'em'
    };
  }
};

function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function createDynamicHighlightingRule(query) {
  var queryPattern = query.filter(function (word) {
    return word.length > 0;
  }).map(escapeRegExp).join('|');
  var regex = queryPattern.length > 0 ? RegExp("(\\b\\S*(?:" + queryPattern + ")\\S*\\b)", 'i') : /\\u0000/;
  return {
    name: 'DynamicHighlight',
    scope: domain_1.RuleScope.INLINE,
    regex: regex,
    parse: function parse(match) {
      return {
        name: this.name,
        content: [match.capture[0]]
      };
    },
    react: function react(node) {
      return {
        type: 'em'
      };
    }
  };
}

exports.createDynamicHighlightingRule = createDynamicHighlightingRule;
exports.BoldRule = {
  name: 'Bold',
  scope: domain_1.RuleScope.INLINE,
  regex: /_([^_]+?)_(?!_)/,
  parse: function parse(match) {
    return {
      name: this.name,
      content: [match.capture[0]]
    };
  },
  react: function react(node) {
    return {
      type: 'b'
    };
  }
};
exports.LinkRule = {
  name: 'Link',
  scope: domain_1.RuleScope.INLINE,
  regex: /((?:[\w-]+:\/\/?|www(?:-\w+)?\.)[^\s()<>]+\w)/,
  startsWithHttp: /^(https?):\/\/.*$/,
  parse: function parse(match) {
    return {
      name: this.name,
      content: [match.capture[0]]
    };
  },
  react: function react(node) {
    var text = utils_1.getText(node);
    var href = this.startsWithHttp.test(text) ? text : "https://" + text;
    return {
      type: 'a',
      props: {
        href: href,
        target: '_blank',
        rel: 'noopener'
      }
    };
  }
};
exports.BulletRule = {
  name: 'Bullets',
  scope: domain_1.RuleScope.BLOCK,
  regex: /((?:^|\n)(?:\*\s[^\n]+(?:\n+|$))+)/,
  parse: function parse(match) {
    var _this = this;

    var content = match.capture[0].split('\n').filter(function (line) {
      return line.length > 0;
    }).map(function (line) {
      return line.replace(/^\*\s+/, '');
    }).map(function (line) {
      return {
        name: _this.name + "__element",
        content: [line]
      };
    });
    return {
      name: this.name,
      content: content
    };
  },
  react: function react(node) {
    return {
      type: 'ul'
    };
  },
  extraRenderers: {
    'Bullets__element': function Bullets__element(node) {
      return {
        type: 'li'
      };
    }
  }
};